import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=5d9681f6&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports